export default {
  sections: [
  {
    "id": "installer",
    "title": "Installer Details",
    "repeatable": false,
    "fields": [
      {
        "id": "companyName",
        "type": "text",
        "label": "Company Name",
        "required": true
      },
      {
        "id": "oftecNumber",
        "type": "text",
        "label": "OFTEC Registration Number",
        "required": true
      },
      {
        "id": "address",
        "type": "textarea",
        "label": "Address",
        "required": true
      },
      {
        "id": "tel",
        "type": "tel",
        "label": "Telephone",
        "required": true
      },
      {
        "id": "email",
        "type": "text",
        "label": "Email"
      }
    ]
  },
  {
    "id": "installation",
    "title": "Installation Address",
    "repeatable": false,
    "fields": [
      {
        "id": "address",
        "type": "textarea",
        "label": "Installation Address",
        "required": true
      },
      {
        "id": "postCode",
        "type": "text",
        "label": "Post Code",
        "required": true
      },
      {
        "id": "customerName",
        "type": "text",
        "label": "Customer Name",
        "required": true
      }
    ]
  },
  {
    "id": "equipment",
    "title": "Equipment Installed",
    "repeatable": false,
    "fields": [
      {
        "id": "applianceType",
        "type": "select",
        "label": "Appliance Type",
        "required": true,
        "options": [
          "Boiler",
          "Cooker",
          "Range",
          "Water Heater",
          "Other"
        ]
      },
      {
        "id": "make",
        "type": "text",
        "label": "Make",
        "required": true
      },
      {
        "id": "model",
        "type": "text",
        "label": "Model",
        "required": true
      },
      {
        "id": "burnerType",
        "type": "select",
        "label": "Burner Type",
        "options": [
          "Pressure Jet",
          "Vaporising",
          "Other"
        ]
      },
      {
        "id": "fuelType",
        "type": "select",
        "label": "Fuel Type",
        "options": [
          "Kerosene (28 sec)",
          "Gas Oil (35 sec)",
          "Other"
        ]
      }
    ]
  },
  {
    "id": "certification",
    "title": "Certification",
    "repeatable": false,
    "fields": [
      {
        "id": "installationDate",
        "type": "date",
        "label": "Installation Date",
        "required": true
      },
      {
        "id": "certificateNumber",
        "type": "text",
        "label": "Certificate Number",
        "required": true
      },
      {
        "id": "engineerSignature",
        "type": "signature",
        "label": "Engineer Signature",
        "required": true
      },
      {
        "id": "engineerName",
        "type": "text",
        "label": "Engineer Name (Print)",
        "required": true
      },
      {
        "id": "customerSignature",
        "type": "signature",
        "label": "Customer Signature"
      }
    ]
  },
  {
    "id": "combustion",
    "title": "Combustion Test Results (OFTEC / BS 5410)",
    "repeatable": false,
    "fields": [
      {
        "id": "combustionTestPerformed",
        "type": "select",
        "label": "Combustion Test Performed",
        "required": false,
        "options": ["Yes", "No"]
      },
      {
        "id": "o2Pct",
        "type": "number",
        "label": "O₂ (%)",
        "placeholder": "e.g. 4.5"
      },
      {
        "id": "co2Pct",
        "type": "number",
        "label": "CO₂ (%)",
        "placeholder": "e.g. 12.5"
      },
      {
        "id": "coPpm",
        "type": "number",
        "label": "CO (ppm)",
        "placeholder": "e.g. 45"
      },
      {
        "id": "flueTempC",
        "type": "number",
        "label": "Flue Gas Temperature (°C)",
        "placeholder": "e.g. 180"
      },
      {
        "id": "ambientTempC",
        "type": "number",
        "label": "Ambient Air Temperature (°C)",
        "placeholder": "e.g. 20"
      },
      {
        "id": "smokeNumber",
        "type": "number",
        "label": "Smoke Pump Test Number (0-9)",
        "placeholder": "0-1 normal"
      },
      {
        "id": "pumpPressureBar",
        "type": "number",
        "label": "Pump Pressure (bar)",
        "placeholder": "e.g. 10"
      },
      {
        "id": "vacuumReadingMbar",
        "type": "number",
        "label": "Vacuum Reading (mbar)",
        "placeholder": "e.g. 0.8"
      }
    ]
  },
  {
    "id": "supplyAndTank",
    "title": "Oil Supply & Tank Compliance",
    "repeatable": false,
    "fields": [
      {
        "id": "supplySystem",
        "type": "select",
        "label": "Oil Supply System",
        "options": ["Gravity Feed", "Sub-Grade Suction", "Lift (De-aerator)"]
      },
      {
        "id": "tigerloopFitted",
        "type": "select",
        "label": "De-aerator (Tigerloop) Fitted",
        "options": ["Yes", "No"]
      },
      {
        "id": "oilFilterCondition",
        "type": "select",
        "label": "Oil Filter Condition",
        "options": ["Satisfactory", "Replaced", "Unsatisfactory"]
      },
      {
        "id": "fireValveFitted",
        "type": "select",
        "label": "Remote Fire Valve Fitted",
        "options": ["Yes", "No"]
      },
      {
        "id": "fireValveTripC",
        "type": "number",
        "label": "Fire Valve Trip Temperature (°C)",
        "placeholder": "e.g. 99"
      },
      {
        "id": "tankType",
        "type": "select",
        "label": "Tank Type",
        "required": false,
        "options": ["Bunded", "Single Skin", "Integrally Bunded"]
      },
      {
        "id": "tankCapacityLitres",
        "type": "number",
        "label": "Tank Capacity (litres)",
        "placeholder": "e.g. 1200"
      },
      {
        "id": "distanceToBuildingM",
        "type": "number",
        "label": "Distance to Building (m)",
        "placeholder": "BS 5410 min 1.8m"
      },
      {
        "id": "distanceToBoundaryM",
        "type": "number",
        "label": "Distance to Boundary (m)",
        "placeholder": "BS 5410 min 0.76m"
      },
      {
        "id": "fireScreenFitted",
        "type": "select",
        "label": "Fire Protection Screen Fitted",
        "options": ["Yes", "No"]
      }
    ]
  }
]
};
